module.exports = __webpack_public_path__ + "media/images/icons/edit-719e2ddf7a0b223629100a4a46915493.svg";